var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1296_9041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.447 19.7527C11.6126 19.6715 11.7521 19.5455 11.8499 19.3891C11.9476 19.2327 11.9996 19.0521 12 18.8677V13.5477C12 13.2857 12.105 13.0337 12.293 12.8477L18.414 6.79367C18.5994 6.61065 18.7466 6.39268 18.8472 6.15237C18.9478 5.91206 18.9997 5.65419 19 5.39367V2.83767C18.9995 2.70697 18.9732 2.57765 18.9226 2.45713C18.8721 2.3366 18.7982 2.22723 18.7053 2.13527C18.6124 2.04331 18.5023 1.97058 18.3813 1.92123C18.2603 1.87188 18.1307 1.84688 18 1.84767H2C1.447 1.84767 1 2.28967 1 2.83767V5.39367C1 5.91867 1.211 6.42267 1.586 6.79367L7.707 12.8477C7.79974 12.9392 7.8734 13.0481 7.92369 13.1683C7.97399 13.2885 7.99993 13.4174 8 13.5477V19.8577C8 20.5927 8.782 21.0707 9.447 20.7417L11.447 19.7527V19.7527Z",
    stroke: "#F89500",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1296_9041",
    x: 0,
    y: 0.847656,
    width: 20.3333,
    height: 21.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1296_9041"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.caa174f02339677f1b80df06856b533d.svg";
export { ForwardRef as ReactComponent };